<template>
  <right-menu-item
    @click.prevent="click"
    :class="{'!text-red-600': !loading && show, 'muted': !show}"
    :text="$t('Remove user')"
    :loading="loading"
    icon="trash"
  />
</template>

<script>
import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import { showConfirm } from '../BcConfirm'
import NetteAjax from 'nette-base-module/js/nette/NetteAjax'

export default {
  data() {
    return {
      loading: false
    }
  },
  computed: {
    show() {
      return this.bcSelectedStore.listSelected.length > 0
        && this.bcSelectedStore.listSelected[0]._rowActions.removelink

    },
    username() {
      if (this.bcSelectedStore.listSelected.length == 0) {
        return null
      }

      return this.bcSelectedStore.listSelected
        .filter((user) => user._rowActions.removelink)
        .map((user) => user.surname.name).join(', ')
    },
    ...mapStores(useBcSelectedStore)
  },
  methods: {
    async click() {
      //TODO: confirm text
      const confirm = await showConfirm({
        header: this.$t('Do you want to remove %username% from this team?', { username: this.username })
      })

      if (!confirm) {
        return
      }

      this.loading = true
      let removeIds = this.bcSelectedStore.listSelected.filter((user) => user._rowActions.removelink).map((user) => user._id).join(',')
      await NetteAjax.ajax({
        url: this.$presenter.removeUsersLink.replace('IDS', removeIds),
        onSuccess: () => {
          this.bcSelectedStore.resetSelected()
        }
      })

      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped></style>
